import React, { FunctionComponent } from 'react';

import { BilikActor, MongoEvent } from 'interfaces/events.interface';
import TimelineEvent from '../timeline-event';
import { PhoneNumber } from 'utils';

type SmsReceivedProps = {
  event: MongoEvent;
};

// SMS send by pi to pro on twilio number
const SmsReceived: FunctionComponent<SmsReceivedProps> = ({ event }) => {
  const proTargetTelephone =
    event.actors.pro?.proView?.callTrackingTarget?.telephone;

  const getMessageText = (event: MongoEvent): string => {
    switch (event.version) {
      case 0:
        return event.data.callrMessage.text;
      case 1:
        return event.data.callrMessage.text;
      case 2:
        return event.data.twilio.Body;
      case 3:
        return event.data.vonage.text;
      default:
        return event.data.vonage.text;
    }
  };

  const getBilikMainCity = (bilik: BilikActor): string => {
    switch (event.version) {
      case 1:
        return bilik.bilikZone.mainCity as any; // Any because In v1, mainCity was a string
      case 0 | 2 | 3:
        return bilik.bilikZone.mainCityCode;
      default:
        return bilik.bilikZone.mainCityCode;
    }
  };

  return (
    <TimelineEvent
      color={event.data.isSpam ? 'red' : 'blue'}
      date={event.date}
      icon="mobile alternate"
      title={
        event.initiator.pi && event.actors.pro ? 'SMS au pro' : 'SMS à Bilik'
      }
      initiator="particulier"
      takingContact={event.data.isFirstContact}
    >
      {/* Sms to pro */}
      {event.initiator.pi && event.actors.pro ? (
        <>
          <h3>
            {event.data.resendBy ? (
              <>
                <span>
                  {event.data.resendBy.givenName}{' '}
                  {event.data.resendBy.familyName}
                </span>{' '}
                a renvoyé le{' '}
              </>
            ) : (
              <>
                Le particulier a{' '}
                {event.data.isSpam ? "tenté d'envoyer" : 'envoyé'} un{' '}
              </>
            )}
            SMS à <span>{event.actors.pro.proPresentation.name}</span>
          </h3>
          {event.data.isSpam ? (
            <section
              style={{
                color: 'red',
              }}
            >
              <i>Suspicion de spam, ce sms n&apos;a pas été transféré au pro</i>
            </section>
          ) : null}
          <section>
            <p>
              <b>Message : </b>
              {getMessageText(event)}

              {!proTargetTelephone ||
              !PhoneNumber.isSmsCapable(proTargetTelephone) ? (
                <>
                  <i>Ce sms a été transféré au pro par email</i>
                </>
              ) : null}
            </p>
          </section>
        </>
      ) : null}
      {/* Sms to bilikZone */}
      {event.initiator.pi && event.actors.bilik ? (
        <>
          <>
            <h3>
              Le particulier a envoyé un SMS à{' '}
              <span>Bilik {getBilikMainCity(event.actors.bilik)}</span>
            </h3>
            <section>
              <p>
                <b>Message: </b>
                {getMessageText(event)}
              </p>
            </section>
          </>
        </>
      ) : null}
    </TimelineEvent>
  );
};

export default SmsReceived;
